/**
 * 文本编辑器
 * 2020/1/3
 */
import React from 'react';
import BraftEditor from 'braft-editor';
import 'braft-editor/dist/index.css';

class EditorContent extends React.Component {
    state = {
        outputHTML: '',
        editorState: BraftEditor.createEditorState(null), // 设置编辑器初始内容
        editorFlag: false,
    };
    componentDidMount() {
        if (this.props.getValueRef) {
            this.props.getValueRef(this.getValue);
        }
    }

    componentWillReceiveProps(that) {
        if(!that.editorFlag){
            this.setState({
                editorFlag:false,
            })
        }
    }

    handleChange = (editorState) => {
        if(this.props.editorFlag){
            this.setState({
                editorState: editorState,
                editorFlag: true,
            })
        }
    }

    getValue = () => {
        return this.state.editorState.toHTML();
    }

    render() {
        const editorState = this.state.editorFlag? this.state.editorState : BraftEditor.createEditorState(this.props.editDataContent);
        return (
            <div style={{ width: '100%', height: '100%', border: '1px solid #d9d9d9', borderRadius: '5px' }}>
                <BraftEditor
                    value={editorState}
                    onChange={this.handleChange} />
            </div>
        )   
    }

}

export default EditorContent;